/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Endpoint_Provider_ServedInputs */

const en_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} served`)
};

const zh_hans1_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已服务 ${i?.count}`)
};

const pt_br2_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} atendidas`)
};

const es_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} atendidas`)
};

const fr_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} servis`)
};

const de_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} bedient`)
};

const ru_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обслужено: ${i?.count}`)
};

const it_endpoint_provider_served = /** @type {(inputs: Endpoint_Provider_ServedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} serviti`)
};

/**
* | output |
* | --- |
* | "{count} served" |
*
* @param {Endpoint_Provider_ServedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_provider_served = /** @type {((inputs: Endpoint_Provider_ServedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Provider_ServedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_provider_served(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_provider_served(inputs)
	if (locale === "es") return es_endpoint_provider_served(inputs)
	if (locale === "fr") return fr_endpoint_provider_served(inputs)
	if (locale === "de") return de_endpoint_provider_served(inputs)
	if (locale === "ru") return ru_endpoint_provider_served(inputs)
	if (locale === "it") return it_endpoint_provider_served(inputs)
	return en_endpoint_provider_served(inputs)
});